// Legacy is classified by catalog version (ADR-0001: `version` is deprecated,
// `catalogVersion` canonical). v3 and 2026_module_v1 are modern.
const LEGACY_CATALOG_VERSIONS: string[] = ["v1", "v2"];

// Legacy only when every subscription is legacy: a modern sub (e.g.
// 2026_module_v1) alongside a legacy one must not show the legacy banner.
// Lexical max would mis-pick here since 2026_module_v1 sorts below vN.
export const isLegacyPlan = (
  subscriptions: Array<{ catalogVersion?: string | null; version: string }>
): boolean => {
  if (subscriptions.length === 0) {
    return false;
  }
  return subscriptions.every((subscription) =>
    LEGACY_CATALOG_VERSIONS.includes(
      subscription.catalogVersion ?? subscription.version
    )
  );
};
